<template lang="html">
	<section class="subview-container column">
		<div class="profile-container">
			<div class="header-part row">
				<div class="ctn-profile-light row">
					<div class="ctn-profile-picture">
						<img id="userPicture" v-img-detect :src="userM.picture" alt="">
					</div>
					<div class="ctn-label">
						<div class="ctn-name" v-if="isAnonymous">
							Compte Anonyme
						</div>
						<div class="ctn-name" v-else>
							{{ user.firstname }} {{ user.lastname }}
						</div>
						<div class="link" @click="procNewPicture" v-if="!isAnonymous">
							Éditer la photo
							<input id="newPicture" type="file" v-on:change="uploadNewPicture">
						</div>
					</div>
				</div>
				<div class="ctn-logout">
					<div class="btn btn-red" @click="logout">
						Déconnexion
					</div>
				</div>
			</div>
			<div class="body-part row" v-if="isAnonymous">
				<div class="ctn-anonymous-title">
					<div class="title">
						Inscription
					</div>
					<div class="text">
						Afin d’obtenir un conseil personnalisé inscrivez-vous en complétant les informations ci-dessous.
						<br> Toutes vos données saisies dans le paysage patrimonial en mode anonyme seront conservées et vous pourrez les modifier à tout moment.
					</div>
					<router-link class="btn btn-red" :to="{name: 'AnonymousUpgrade'}">
						Inscription <i class="icon-arrow-full-right"></i>
					</router-link>
				</div>
			</div>
			<div class="body-part row" v-else>
				<div class="half edit-profile">
					<form class="default-form-ui" novalidate>
						<div class="title">
							Informations générales
						</div>
						<div class="form-elem-container">
							<div class="ctn-input ctn-label" :class="{error: errors.has('email')}">
								<input type="email" v-validate="'required|email'" name="email" v-model="userM.email" placeholder="Email">
							</div>
							<div v-if="errors.has('email')" class="error-message">{{ errors.first('email') }}</div>
						</div>
						<div class="form-elem-container">
							<div class="ctn-input ctn-label" :class="{error: errors.has('prénom')}">
								<input type="text" v-validate="'required|alpha_dash_spaces'" name="prénom" v-model="userM.firstname" placeholder="Prénom">
							</div>
							<div v-if="errors.has('prénom')" class="error-message">{{ errors.first('prénom') }}</div>
						</div>
						<div class="form-elem-container">
							<div class="ctn-input ctn-label" :class="{error: errors.has('nom')}">
								<input type="text" v-validate="'required|alpha_dash_spaces'" name="nom" v-model="userM.lastname" placeholder="Nom">
							</div>
							<div v-if="errors.has('nom')" class="error-message">{{ errors.first('nom') }}</div>
						</div>
						<div class="form-elem-container">
							<div class="ctn-input ctn-label" :class="{error: errors.has('date de naissance')}">
								<input type="date" v-validate="'required'" name="date de naissance" v-model="userM.birthdate" placeholder="Date de naissance">
							</div>
							<div v-if="errors.has('date de naissance')" class="error-message">{{ errors.first('date de naissance') }}</div>
						</div>
						<div class="form-elem-container">
							<div class="ctn-input ctn-label" :class="{error: errors.has('adresse')}">
								<input type="text" v-validate="'required'" name="adresse" v-model="userM.address.line" placeholder="Adresse">
							</div>
							<div v-if="errors.has('adresse')" class="error-message">{{ errors.first('adresse') }}</div>
						</div>
						<div class="form-elem-container">
							<div class="ctn-input ctn-label" :class="{error: errors.has('code postal')}">
								<input type="text" v-validate="'required|numeric|length:5'" name="code postal" v-model="userM.address.zip" placeholder="Code postal">
							</div>
							<div v-if="errors.has('code postal')" class="error-message">{{ errors.first('code postal') }}</div>
						</div>
						<div class="form-elem-container">
							<div class="ctn-input ctn-label" :class="{error: errors.has('ville')}">
								<input type="text" v-validate="'required|alpha_spaces'" name="ville" v-model="userM.address.city" placeholder="Ville">
							</div>
							<div v-if="errors.has('ville')" class="error-message">{{ errors.first('ville') }}</div>
						</div>
						<div class="form-elem-container">
							<div class="ctn-input ctn-label" :class="{error: errors.has('pays')}">
								<input type="text" v-validate="'required|alpha_spaces'" name="pays" v-model="userM.address.country" placeholder="Pays">
							</div>
							<div v-if="errors.has('pays')" class="error-message">{{ errors.first('pays') }}</div>
						</div>
						<div class="form-elem-container">
							<div class="ctn-input ctn-label" :class="{error: errors.has('téléphone')}">
								<input type="text" v-validate="'required'" name="téléphone" v-model="userM.phone" placeholder="Téléphone">
							</div>
							<div v-if="errors.has('téléphone')" class="error-message">{{ errors.first('téléphone') }}</div>
						</div>
					</form>
				</div>
				<div class="half edit-password column">
					<form class="form-ui default-form-ui" novalidate>
						<div class="item">
							<div class="title">
								Mot de passe
							</div>
							<div class="link" @click="displayChangePassword = true">
								Modifier le mot de passe
							</div>
						</div>
					</form>
					<div class="btn btn-red save" @click="saveProfile">
						Sauvegarder
					</div>
				</div>
			</div>
		</div>
		<base-modal :show="displayChangePassword" @close="displayChangePassword = false" :content="contentModalPassword" />
	</section>
</template>

<script>
import ModalChangePassword from '@/components/modal/ChangePassword'
import { mapGetters } from 'vuex'
import { Validator } from 'vee-validate'

Validator.extend('alpha_dash_spaces', {
	getMessage: field => 'Le champ ' + field + ' ne peut contenir que des caractères des tirets et des espaces',
	validate: value => {
		for (let i = 0; i < value.length; i++) {
			if ('aàbcçdeéèfghijklmnopqrstuvwxyz -'.indexOf(value[i].toLowerCase()) === -1) { return false }
		}
		return true
	}
})

export default {
	name: 'Profile',
	data () {
		return {
			userM: {
				email: null,
				firstname: null,
				lastname: null,
				birthdate: null,
				address: {
					line: null,
					zip: null,
					city: null,
					country: null
				},
				phone: null,
				picture: null,
				password: null
			},
			isAvailable: false,
			displayChangePassword: false,
			contentModalPassword: ModalChangePassword,
			mailNotif: false,
			acceptCGU: false,
			acceptDER: false,
			error: {
				cgu: false,
				der: false
			}
		}
	},
	mounted () {
		this.userM = {
			email: this.user.email,
			firstname: this.user.firstname,
			lastname: this.user.lastname,
			address: {
				line: (this.user.address.line && this.user.address.line !== 'null') ? this.user.address.line : null,
				zip: (this.user.address.zip && this.user.address.zip !== 'null') ? this.user.address.zip : null,
				city: (this.user.address.city && this.user.address.city !== 'null') ? this.user.address.city : null,
				country: (this.user.address.country && this.user.address.country !== 'null') ? this.user.address.country : null
			},
			phone: this.user.phone,
			birthdate: this.user.birthdate ? this.user.birthdate.split('-').reverse().join('-') : null,
			picture: (this.user.picture) ? process.env.ASSETS_ROOT + this.user.picture : process.env.API_ROOT + '/assets/user.png',
			password: null,
			newPassword1: null,
			newPassword2: null
		}
	},
	computed: {
		...mapGetters({
			user: 'user',
			isAnonymous: 'isAnonymous'
		})
	},
	methods: {
		uploadNewPicture (value) {
			const preview = document.getElementById('userPicture')
			const file = value.path[0].files[0]
			const reader = new FileReader()

			reader.addEventListener('load', () => {
				preview.src = reader.result
				this.$store.dispatch('updateProfilePicture', reader.result)
			})

			if (file) {
				reader.readAsDataURL(file)
			}
		},
		procNewPicture () {
			document.getElementById('newPicture').click()
		},
		saveProfile () {
			this.$validator.validate().then((result) => {
				if (result) {
					if (!this.isAnonymous || (this.acceptCGU && this.acceptDER)) {
						const shouldLogout = (this.user.email !== this.userM.email)
						this.$store.dispatch('saveProfile', this.userM).then(() => {
							let text = 'Les modifications ont été apporté à votre profile'
							if (this.isAnonymous) {
								text = 'Votre compte a été validé, veuillez confirmer votre adresse email'
							} else if (shouldLogout) {
								text = 'Pour valider cette modification vous devrez vous authentifier à nouveau avec votre nouvel email et votre mot de passe actuel'
							}
							this.$notify({
								type: 'success',
								group: 'default',
								title: 'Félicitations',
								text: text
							})
							if (this.isAnonymous || shouldLogout) {
								this.$store.dispatch('allClear')
								this.$router.push({ name: 'Login' })
							}
						}).catch((error) => {
							let message = ''
							if (Object.keys(error.response.data.errors).indexOf('email') !== -1) message = 'Cette adresse email est déjà utilisé'
							this.$notify({
								type: 'error',
								group: 'default',
								title: 'Une erreur est survenue',
								text: message
							})
						})
					} else {
						this.error.cgu = !this.acceptCGU
						this.error.der = !this.acceptDER
					}
				}
			})
		},
		setAvailable (val) {
			this.isAvailable = val
			this.showUnavailable = !val
		},
		logout () {
			this.$store.dispatch('logout').then(() => {
				this.$router.push({ name: 'Login' })
			})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/views/Profile.vue